import React, { useEffect, useState } from "react";
import GrayCard from "components/gray-card";
import styled from "styled-components";
import Typography from "components/typography";
import { Colors } from "utils/colors";
import Dropdown from "components/inputs/dropdown";

interface IProps {
  time?: string;
  setReleaseTime: (time: string) => void;
}
const ReleaseTime = ({ time = "1:00", setReleaseTime }: IProps) => {
  const convertTo12HourFormat = (time24: string) => {
    const [hour24, minute] = time24.split(":").map(Number);

    const meridiem = hour24 >= 12 ? "PM" : "AM";

    let hour = hour24 % 12;
    hour = hour === 0 ? 12 : hour;

    return {
      hour: String(hour),
      minute: String(minute).padStart(2, "0"),
      meridiem
    };
  };
  const [hour, setHour] = useState(convertTo12HourFormat(time).hour);
  const [minute, setMinute] = useState(convertTo12HourFormat(time).minute);
  const [meridiem, setMeridiem] = useState(
    convertTo12HourFormat(time).meridiem
  );
  const hours = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
  const minutes = Array.from({ length: 60 }, (_, i) =>
    String(i).padStart(2, "0")
  );

  const saveTimeIn24HourFormat = () => {
    let hour24 = parseInt(hour, 10);
    if (meridiem === "PM" && hour24 !== 12) {
      hour24 += 12;
    } else if (meridiem === "AM" && hour24 === 12) {
      hour24 = 0;
    }

    const time24 = `${String(hour24).padStart(2, "0")}:${minute}`;

    return time24;
  };

  useEffect(() => {
    setReleaseTime(saveTimeIn24HourFormat());
  }, [hour, minute, meridiem]);
  return (
    <GrayCard title="Release Time " subtitle="(Spotify Only)">
      <TimeContainer>
        <TimeDrop>
          <Dropdown
            chosenItem={hour}
            items={hours}
            selectItem={(value) => setHour(value)}
          />
        </TimeDrop>
        <Typography mr="1" size="xl" color={Colors.white100}>
          :
        </Typography>
        <TimeDrop>
          <Dropdown
            chosenItem={minute}
            selectItem={(value) => setMinute(value)}
            items={minutes}
          />
        </TimeDrop>
        <TimeDrop>
          <Dropdown
            chosenItem={meridiem}
            items={["AM", "PM"]}
            selectItem={(value) => {
              setMeridiem(value);
            }}
          />
        </TimeDrop>
      </TimeContainer>
      <Note>
        <InfoIcon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 12 12"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11 6C11 8.7614 8.7614 11 6 11C3.23857 11 1 8.7614 1 6C1 3.23857 3.23857 1 6 1C8.7614 1 11 3.23857 11 6ZM6 8.875C6.2071 8.875 6.375 8.7071 6.375 8.5V5.5C6.375 5.2929 6.2071 5.125 6 5.125C5.7929 5.125 5.625 5.2929 5.625 5.5V8.5C5.625 8.7071 5.7929 8.875 6 8.875ZM6 3.5C6.27615 3.5 6.5 3.72386 6.5 4C6.5 4.27614 6.27615 4.5 6 4.5C5.72385 4.5 5.5 4.27614 5.5 4C5.5 3.72386 5.72385 3.5 6 3.5Z"
              fill="#909090"
            />
          </svg>
        </InfoIcon>
        <Typography size="s" ml="0.4" color={Colors.grey500}>
          What time (on your release date) should this go live on Spotify?
          Other(non-Spotify) stores will be midnight-ish in each country
        </Typography>
      </Note>
    </GrayCard>
  );
};

export default ReleaseTime;

const TimeContainer = styled.div`
  display: flex;
  align-items: center;
`;
const TimeDrop = styled.div`
  width: 8rem;
  margin-right: 1rem;
`;
const Note = styled.div`
  display: flex;
  align-items: center;
  margin-top: 2.4rem;
`;

const InfoIcon = styled.div`
  width: 1.2rem;
  height: 1.2rem;
`;
